import {webRequest, webNoTokenRequest} from '../api'

// 入住點交頁面 {contractSeq: String}
export function getCheckInPage(params) {
    return webRequest({
        url:'/v2/oauth/order/manage/checkIn/page',
        method:'get',
        params: params
    })
}
// 房東發起入住點交
// {
//     "contractSeq" : "CT210618000005",
//     "waterMeter" : 10,
//     "electricityMeter" : 20,
//     "gasMeter" : 30
// }
export function checkIn(data) {
    return webRequest({
        url:'/v2/oauth/order/manage/check/in',
        method:'post',
        data: data,
    })
}
// 刪除紙本合約
export function delPaperContract(data) {
    return webRequest({
        url:'/oauth/order/manage/contracts/delete/paperContract',
        method:'post',
        data: data,
    })
}


// WEBPACK FOOTER //
// ./src/apis/landlord/leaseMgt.js